import {ref} from 'vue'
import {useStorage} from '@vueuse/core/index'
import {GridApi} from 'ag-grid-community'

export const newPresetName = ref('')

export const presets = useStorage('bi-grid-presets', {} as Record<string, any>)

export const savePreset = (gridApi: GridApi) => {
    if(!gridApi) {
        return
    }
    presets.value[newPresetName.value] = gridApi.getState()
}

export const restorePreset = (gridApi: GridApi, presetName: string) => {
    const preset = presets.value[presetName]
    if(!preset) {
        return
    }
    gridApi.setState(preset)
}

export const deletePreset = (presetName: string) => {
    const preset = presets.value[presetName]
    if(!preset) {
        console.warn('No preset found with name', presetName)
        return
    }
    delete presets.value[presetName]
}